import React, { useState } from 'react';
import {
  Box,
  Button,
  Grid,
  Alert,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  TextField,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { Formik } from "formik";
import * as Yup from "yup";
import AttachmentIcon from '@mui/icons-material/Attachment';
import { Breadcrumb, SimpleCard } from 'app/components';
import { useDispatch } from 'react-redux'; 
// import { addLeaveRequest } from 'app/redux/actions/leave/leaveActions';

export default function LeaveRequest() {
    // const dispatch = useDispatch(); 
    const [isSubmitted, setIsSubmitted] = useState(false);

    const initialValues = {
        startDate: null,
        endDate: null,
        reason: '',
        attachment: null,
        status: 'Pending',
        type: '',
    };

    const validationSchema = Yup.object().shape({
        startDate: Yup.date().required('Start date is required'),
        endDate: Yup.date().required('End date is required'),
        reason: Yup.string().required('Reason is required'),
        attachment: Yup.mixed().required('Attachment is required'),
        type: Yup.string().required('Leave type is required'),
    });

    const handleSubmit = async (values) => {
        // const newLeaveRequest = {
        //     id: new Date().getTime(),
        //     startDate: values.startDate,
        //     endDate: values.endDate,
        //     reason: values.reason,
        //     attachment: values.attachment,
        //     status: values.status,
        //     type: values.type,
        // };
        // dispatch(addLeaveRequest(newLeaveRequest));
        setIsSubmitted(true);
    };

    return (
        <SimpleCard>
            <Box>
                <Breadcrumb routeSegments={[{ name: "Leave Request" }]} />
            </Box>
            &nbsp;

            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    setFieldValue
                }) => (
                    <form onSubmit={handleSubmit}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth variant="outlined" error={Boolean(touched.type && errors.type)}>
                                    <InputLabel id="leave-type-label">Leave Type</InputLabel>
                                    <Select
                                        labelId="leave-type-label"
                                        name="type"
                                        value={values.type}
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        label="Leave Type"
                                    >
                                        <MenuItem value="Sick Leave">Sick Leave</MenuItem>
                                        <MenuItem value="Vacation Leave">Vacation Leave</MenuItem>
                                        <MenuItem value="Emergency Leave">Emergency Leave</MenuItem>
                                    </Select>
                                    {touched.type && errors.type && (
                                        <Alert severity="error">{errors.type}</Alert>
                                    )}
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <LocalizationProvider dateAdapter={AdapterLuxon}>
                                    <DatePicker
                                        label="Start Date"
                                        value={values.startDate}
                                        onChange={(newValue) => setFieldValue("startDate", newValue)}
                                        renderInput={(params) => <TextField {...params} fullWidth error={Boolean(touched.startDate && errors.startDate)} />}
                                    />
                                    {touched.startDate && errors.startDate && (
                                        <Alert severity="error">{errors.startDate}</Alert>
                                    )}
                                </LocalizationProvider>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <LocalizationProvider dateAdapter={AdapterLuxon}>
                                    <DatePicker
                                        label="End Date"
                                        value={values.endDate}
                                        onChange={(newValue) => setFieldValue("endDate", newValue)}
                                        renderInput={(params) => <TextField {...params} fullWidth error={Boolean(touched.endDate && errors.endDate)} />}
                                    />
                                    {touched.endDate && errors.endDate && (
                                        <Alert severity="error">{errors.endDate}</Alert>
                                    )}
                                </LocalizationProvider>
                            </Grid>

                            <Grid item xs={12}>
                                <TextField
                                    label="Reason"
                                    name="reason"
                                    fullWidth
                                    multiline
                                    rows={4}
                                    value={values.reason}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={Boolean(touched.reason && errors.reason)}
                                />
                                {touched.reason && errors.reason && (
                                    <Alert severity="error">{errors.reason}</Alert>
                                )}
                            </Grid>

                            <Grid item xs={12}>
                                <Button variant="contained" component="label" startIcon={<AttachmentIcon />}>
                                    Attach Document
                                    <input
                                        type="file"
                                        hidden
                                        onChange={(event) => setFieldValue("attachment", event.currentTarget.files[0])}
                                    />
                                </Button>
                                {touched.attachment && errors.attachment && (
                                    <Alert severity="error">{errors.attachment}</Alert>
                                )}
                            </Grid>

                            <Grid item xs={12}>
                                <Button type="submit" variant="contained">Submit Request</Button>
                                {isSubmitted && (
                                    <Alert severity="success" sx={{ marginTop: 2 }}>
                                        Leave request submitted successfully!
                                    </Alert>
                                )}
                            </Grid>
                        </Grid>
                    </form>
                )}
            </Formik>
        </SimpleCard>
    );
}
